export function tutorialHandler() {
  const wasShown = localStorage.getItem('tutorial-was-shown') === 'true'
  const nav = document.querySelector('#main-nav')
  
  if (!wasShown) {
    const tutorial = document.createElement('div')

    tutorial.innerHTML = `\
    <div id="tutorial-container" class="absolute left-[5rem] top-[5rem] bg-white max-w-[267px] z-50 drop-shadow-md rounded-lg flex flex-col gap-3">\
      <div class="px-5 pt-5 flex justify-between">\
        <h2 class="text-lg text-light-blue">Tutorial</h2>\
        <button id="tutorial-close-button">\
          <img src="../static/img/x.svg" class="stroke-dark-blue" />\
        </button>\
      </div>\
      <p id="tutorial-text" class="px-5 text-light-blue text-opacity-50 font-normal">\
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi quis elit non velit fringilla \
      </p>\
      <div class="flex justify-center gap-2 py-2">\
        <div id="tutorial-page-indicator" class="bg-ecofactory-green w-5 h-1 rounded-md"></div>\
        <div id="tutorial-page-indicator" class="bg-ecofactory-green bg-opacity-50 w-6 h-1 rounded-md"></div>\
        <div id="tutorial-page-indicator" class="bg-ecofactory-green bg-opacity-50 w-6 h-1 rounded-md"></div>\
        <div id="tutorial-page-indicator" class="bg-ecofactory-green bg-opacity-50 w-6 h-1 rounded-md"></div>\
      
      </div>\
      <div class="flex">\
        <button id="tutorial-last-button" class="p-4 flex-1 bg-dark-blue text-white rounded-bl-lg">Anterior</button>\
        <button id="tutorial-next-button" class="p-4 flex-1 bg-ecofactory-green text-white rounded-br-lg">Siguiente</button>\
      </div>\
    </div>\
  `
    nav.appendChild(tutorial)

    const tutorialClose = document.querySelector('#tutorial-close-button')
    const tutorialNext = document.querySelector('#tutorial-next-button')
    const tutorialLast = document.querySelector('#tutorial-last-button')
    const tutorialText = document.querySelector('#tutorial-text')
    const tutorialPageIndicator = document.querySelectorAll('#tutorial-page-indicator')
    const textPages = 3
    let currentTextPage = 0

    const textPagesParagraphs = {
      0: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi quis elit non velit fringilla',
      1: 'Lorem ipsum dolor sit amet, consectetur adipisciit. Morbi quis elit non velit fringilla',
      2: 'Lorem ipsum dolor sit amet, consectetur adipiscing el. Morbi quis elit non velit fringilla',
      3: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit Morbi quis elit non velit fringilla',
    }
    tutorialClose.addEventListener('click', () => {
      tutorial.classList.add('hidden')
      localStorage.setItem('tutorial-was-shown', true)
    })
    tutorialNext.addEventListener('click', () => {
      if (currentTextPage == textPages) return;

      tutorialPageIndicator[currentTextPage].classList.add('bg-opacity-50')
      currentTextPage += 1
      tutorialText.innerHTML = textPagesParagraphs[currentTextPage]
      tutorialPageIndicator[currentTextPage].classList.remove('bg-opacity-50')
    })

    tutorialLast.addEventListener('click', () => {
      if (currentTextPage == 0) return;

      tutorialPageIndicator[currentTextPage].classList.add('bg-opacity-50')
      currentTextPage -= 1
      tutorialText.innerHTML = textPagesParagraphs[currentTextPage]
      tutorialPageIndicator[currentTextPage].classList.remove('bg-opacity-50')
    })
  }
}